import { setStorage, getStorage } from './core';
import geolocation from './geolocation';

/**
 * @file 封装 获取用户定位接口,包括经纬度
 * @author guoyong03
 */

/* globals getApp, Page  */

// get方法 在h5下面 无法获得 province 需要自己处理
export function get(refresh = false, autoSave = true) {
  const locData = getStorage('location');
  if (!refresh && locData && locData !== '') {
    autoSave && set(locData);
    return Promise.resolve(locData);
  } else {
    return new Promise((resolve, reject) => {
      geolocation.getPosition({
        onSuccess(pos) {
          let locData = {
            lat: pos.lat,
            long: pos.long,
            cityCode: pos.cityCode,
            cityName: (pos.addr && pos.addr.city || '').replace('市', ''),
            curCity: (pos.addr && pos.addr.city || '').replace('市', '')
          };
          autoSave && set(locData);
          return resolve(locData);
        },
        onFail(err) {
          console.log('geolocation fail', err); // eslint-disable-line
          return reject('geolocation fail');
        }
      });
    });
  }
}
export function set(loc) {
  let location = {
    // 纬度
    lat: null,
    // 经度
    long: null,
    // 城市和经纬度不一定匹配，城市用户可选择，经纬度始终是当前位置经纬度
    cityCode: null,
    cityName: null,
    curCity: null,
    // 经纬度所在城市
    province: null // 省份，经销商中台接口需要省份
  };

  let currLoc = getApp().globalData.location;
  location = Object.assign(location, currLoc, loc);

  // 更新全局变量
  getApp().globalData.location = Object.assign(getApp().globalData.location, location);

  // 更新本地缓存
  setStorage('location', location);
}
export default {
  set,
  get
}; // eslint-disable-line